import React from 'react';

const SkeletonLoader: React.FC = () => (
  <div className="app-container sidebar-open"> {/* Mimic overall structure */}
    <div className="sidebar open" style={{ backgroundColor: '#e0e0e0', animation: 'pulse 1.5s infinite ease-in-out' }}>
      <div className="sidebar-header" style={{ padding: '20px' }}>
        <div style={{ width: '80%', height: '40px', backgroundColor: '#c0c0c0', margin: '0 auto', borderRadius: '4px' }}></div>
      </div>
      <nav className="sidebar-nav" style={{ marginTop: '30px' }}>
        <ul>
          {Array.from({ length: 5 }).map((_, index) => (
            <li key={index} style={{ marginBottom: '15px', padding: '0 20px' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '24px', height: '24px', backgroundColor: '#c0c0c0', borderRadius: '4px', marginRight: '15px' }}></div>
                <div style={{ width: '70%', height: '20px', backgroundColor: '#c0c0c0', borderRadius: '4px' }}></div>
              </div>
            </li>
          ))}
        </ul>
      </nav>
      <div className="sidebar-footer" style={{ padding: '20px', marginTop: 'auto' }}>
        <ul>
          {Array.from({ length: 2 }).map((_, index) => (
            <li key={index} style={{ marginBottom: '15px' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '24px', height: '24px', backgroundColor: '#c0c0c0', borderRadius: '4px', marginRight: '15px' }}></div>
                <div style={{ width: '70%', height: '20px', backgroundColor: '#c0c0c0', borderRadius: '4px' }}></div>
              </div>
            </li>
          ))}
        </ul>
        <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center' }}>
          <div style={{ width: '24px', height: '24px', backgroundColor: '#c0c0c0', borderRadius: '4px', marginRight: '15px' }}></div>
          <div style={{ width: '50%', height: '20px', backgroundColor: '#c0c0c0', borderRadius: '4px' }}></div>
        </div>
      </div>
    </div>
    <div className="main-content" style={{ padding: '20px', animation: 'pulse 1.5s infinite ease-in-out' }}>
      <div style={{ width: '30%', height: '40px', backgroundColor: '#e0e0e0', borderRadius: '4px', marginBottom: '30px' }}></div>
      <div style={{ display: 'flex', marginBottom: '20px' }}>
        <div style={{ width: '150px', height: '40px', backgroundColor: '#e0e0e0', borderRadius: '4px', marginRight: '10px' }}></div>
        <div style={{ width: '150px', height: '40px', backgroundColor: '#e0e0e0', borderRadius: '4px' }}></div>
      </div>
      <div style={{ width: '100%', height: '200px', backgroundColor: '#e0e0e0', borderRadius: '4px', marginBottom: '20px' }}></div>
      <div style={{ width: '100%', height: '100px', backgroundColor: '#e0e0e0', borderRadius: '4px' }}></div>
    </div>
    <style>{`
      @keyframes pulse {
        0% { opacity: 0.6; }
        50% { opacity: 1; }
        100% { opacity: 0.6; }
      }
      .sidebar.open { display: flex; flex-direction: column; } /* Ensure sidebar flex properties for skeleton */
    `}</style>
  </div>
);

export default SkeletonLoader;
